import { useRecentViewedProducts } from '../../../core/hook/useRecentViewedProducts'
import ListSelection from '../ListSelection/ListSelection'
import { useTranslation } from '../../context/ConfigContext'
import { mapCmsProductsToProducts, sortProductMediaGalleryByRoles } from '../../utils/Product.utils'
import { ROLE_SMALL } from '../../utils/media.utils'
import { FunctionComponent } from 'react'
import Aos from '../Aos/Aos'

type RecentViewedProductsProps = {
  currentProduct: Product
}

const RecentViewedProducts: FunctionComponent<RecentViewedProductsProps> = ({ currentProduct }) => {
  const t = useTranslation()
  const { recentViewedProducts } = useRecentViewedProducts()

  if (!recentViewedProducts?.length) {
    return null
  }

  if (!recentViewedProducts) {
    return []
  }

  const formatedRecentlyViewedProducts = mapCmsProductsToProducts({ items: recentViewedProducts })

  const recentViewedProductsSortBySmallProperty = formatedRecentlyViewedProducts
    .map((data) => {
      if (!data.mediaGallery) {
        return data
      }

      return {
        ...data,
        mediaGallery: sortProductMediaGalleryByRoles(data.mediaGallery, [ROLE_SMALL]),
      }
    })
    .filter((product) => {
      return product.id != currentProduct.id
    })

  return (
    <div className='list-recent-viewed-products'>
      <ListSelection
        items={recentViewedProductsSortBySmallProperty}
        listId='Vu récemment'
        listName="Suggestion page detail"
        name={
          <Aos htmlTag='h3' className='title-h3'>
            {t('Recently Viewed')}
          </Aos>
        }
        parentClassName='list-recent-viewed-products'
        centerInsufficientSlides
        hideColorVariations
      />
    </div>
  )
}

export default RecentViewedProducts
